import React, { useEffect, useState } from "react";
import {
  createIotCalling,
  getIotCalling,
  removeIotCalling,
  updateIotCalling,
} from "src/apis/CMS/iotCalling.api";
import { NotifyConfirm } from "src/components/notify/Notify";
import Pagination from "src/components/Pagination/Pagination";
import { path } from "src/constants/path";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import useControlPanel from "src/hooks/useControlPanel";
import useDebounce from "src/hooks/useDebounce";
import IotCallingPopup from "../../components/Popup/IotCallingPopup";
import IotCallingControlPanel from "../../components/ControlPanel/IotCallingControlPanel";
import ControlPanelSystem from "src/components/controlPanelSystem/ControlPanelSystem";
import { isOpenPopup } from "src/utils/isOpenPopup";
import IotCallingTable from "../../components/Table/IotCallingTable";

const initIotCallingData = {
  list: [],
  total_record: 1,
};

const titlePage = "Iot Calling";

const IotCalling = () => {
  const permissionsAccessControl = useGetPermissionAccessControl();

  const {
    page,
    searchKey,
    numberPage,
    setNumberPage,
    limit,
    setLimit,
    status,
    setStatus,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    handleInputChange,
    handleChangePage,
  } = useControlPanel();

  const [iotCallingData, setIotCallingData] = useState(initIotCallingData);
  const [filterIotCallings, setFilterIotCallings] = useState([]);

  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);

  const [errorsForm, setErrorsForm] = useState({});

  let search = useDebounce(searchKey, 500);

  useEffect(() => {
    const query = {
      page: numberPage,
      limit,
      searchKey: search,
      startDate,
      endDate,
      status,
    };

    getIotCalling(query, (result) => {
      setIotCallingData({ ...result });
      setFilterIotCallings([...result.list]);
    });
  }, [endDate, limit, numberPage, search, startDate, status]);

  useEffect(() => {
    setNumberPage(page);
  }, [page, setNumberPage, status]);

  const actionAfterCreateOrUpdate = (result, callback) => {
    if (result.data?.status === 422) {
      setErrorsForm({ ...result.data.data });
    } else {
      getIotCalling({}, (result) => {
        setIotCallingData({ ...result });
        setFilterIotCallings([...result.list]);
      });
      callback();
      handleOpenPopup(!isOpenPopup, null);
    }
  };

  const addOrEdit = (IotCalling, resetForm) => {
    if (!IotCalling.id) {
      createIotCalling(IotCalling, (result) => {
        actionAfterCreateOrUpdate(result, resetForm);
      });
    } else {
      updateIotCalling(IotCalling.id, IotCalling, (result) => {
        actionAfterCreateOrUpdate(result, resetForm);
      });
    }
  };

  const handleDelete = (iotCallingDeleted) => {
    NotifyConfirm("warning", "Are you delete it ?", (result) => {
      if (result.isConfirmed) {
        const foundIotCallingIndex = iotCallingData.list.findIndex(
          (iotCalling) => iotCalling.id === iotCallingDeleted.id
        );
        if (foundIotCallingIndex !== -1) {
          removeIotCalling(iotCallingDeleted.id);
          iotCallingData.list.splice(foundIotCallingIndex, 1);
          setIotCallingData((prev) => {
            return {
              ...prev,
              list: [...iotCallingData.list],
              total_record: prev.total_record - 1,
            };
          });
          setFilterIotCallings([...iotCallingData.list]);
        }
      }
    });
  };

  const handleOpenPopup = (isOpen, item) => {
    setOpenPopup(isOpen);
    setRecordForEdit(item);
    setErrorsForm({});
  };

  return (
    <div>
      <div className="page-header">
        <h2>{titlePage}</h2>
      </div>

      <IotCallingPopup
        recordForEdit={recordForEdit}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        addOrEdit={addOrEdit}
        errorsForm={errorsForm}
      />

      <IotCallingControlPanel
        permissionsAccessControl={permissionsAccessControl}
        handleOpenPopup={handleOpenPopup}
      >
        <ControlPanelSystem
          searchKey={searchKey}
          handleInputChange={(e) => handleInputChange(e)}
          limit={limit}
          setLimit={setLimit}
          setNumberPage={setNumberPage}
          status={status}
          setStatus={setStatus}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      </IotCallingControlPanel>

      <IotCallingTable
        permissionsAccessControl={permissionsAccessControl}
        data={filterIotCallings}
        handleOpenPopup={handleOpenPopup}
        handleDelete={handleDelete}
        status={status}
      />

      <Pagination
        pathname={path.cmsIotCalling}
        page={numberPage}
        handleChangePage={(page) => handleChangePage(page)}
        limit={limit}
        pageSize={iotCallingData.total_record}
      />
    </div>
  );
};

export default IotCalling;
